$(document).on("mouseover", ".desktop-country-icon", function() {
    try {
        $(".desktop-country-icons-list").removeClass("hidden").addClass("shown")
    } catch {}
}), $(document).on("mouseout", ".country-icons-list", function() {
    try {
        /*console.log("Mouseout country-icons-list"),*/
        $(".desktop-country-icons-list").removeClass("shown").addClass("hidden")
    } catch {}
}), $(document).on("click", ".desktop-country-icon-flag", function() {
    try {
        /*console.log("Clicked desktop-country-icon"),*/
        $(".desktop-country-icons-list").hasClass("hidden") ? $(".desktop-country-icons-list").removeClass("hidden").addClass("shown") : $(".desktop-country-icons-list").removeClass("shown").addClass("hidden")
    } catch {}
}), $(document).on("click", ".country-icons-list-item", function() {
    try {
        if ($(this).attr("name")) {
            var i = $(this).attr("name"),
                t = $(this).attr("flag"),
                a = $(this).attr("store"),
                l = $(this).attr("currency"); /*console.log("Clicked flag '"+i+"' '"+a+"' '"+t+"'")*/ ;
            var e = l,
                f = js_readCookie("ipcountryddcurrency");
            (f == null || f == "") && (f = !1), js_createCookie("ipcountryddname", i, 365), js_createCookie("ipcountryddflag", t, 365), js_createCookie("ipcountryddstore", a, 365), js_createCookie("ipcountryddcurrency", l, 365), $(".country-icons-list-first-item").show(), $(".country-icons-list-countryflag-root-countryname").text(i), $(".country-icons-list-countryflag-root-image").attr("class", function(k, c) {
                return c.replace(/(^|\s)flag-\S+/g, "")
            }), $(".country-icons-list-countryflag-root-image").addClass(t), $(".country-icons-list-first-item .country-icons-list-countryflag-image").attr("class", function(k, c) {
                return c.replace(/(^|\s)flag-\S+/g, "")
            }), $(".country-icons-list-first-item .country-icons-list-countryflag-image").addClass(t), $(".desktop-country-icons-list").hasClass("shown") && $(".desktop-country-icons-list").removeClass("shown").addClass("hidden"), $(".mobile-country-icons-list").hasClass("shown") && $(".mobile-country-icons-list").removeClass("shown").addClass("hidden"), $(".country-icons-list-first-item .country-icons-list-countryname").text(i), $(".country-icons-list-item").show(), $(".country-icons-list-first-item").show(), $(".mobile-nav-trigger.hamburger.hamburger--spin.is-active .hamburger-box").css("visibility", "visible"), $(".mobile-nav-trigger.hamburger.hamburger--spin.is-active").trigger("click"), $(".main-content").removeClass("bodyoff"), $("body").removeClass("bodyoff"), $(".country-autocomplete").val(""), $(".country-autocomplete-mobile").val("");
            var P = js_readCookie("ipcontinentcode"),
                m = js_readCookie("ipcountrycode"); /*console.log("Click Read country cookies '"+m+"' '"+P+"'"),console.log("Clicking geoWorld: '"+m+"' '"+P+"' '"+a+"' '"+t+"' '"+l+"'-'"+e+"'"),*/
            geoWorld(m, P, a, t, e)
        }
    } catch (k) {
        console.log("ERROR err_country_icon_click: " + k.message)
    }
}), $(document).ready(function() {
    try {
      setTimeout(function(){
        try {
          console.log("lang-switcher.js");
          var i, t, a, l;
          i = js_readCookie("ipcountryddname"), t = js_readCookie("ipcountryddflag"), a = js_readCookie("ipcountryddstore"), l = js_readCookie("ipcountryddcurrency"), console.log("Cookie flag '" + t + "'");
          var e = !1;
          i != null && t != null ? (console.log("Ready saved flag '" + i + "' '" + a + "' '" + t + "'"), $(".country-icons-list-countryflag-root-image").attr("class", function(k, c) {
              return c.replace(/(^|\s)flag-\S+/g, "")
          }), $(".country-icons-list-countryflag-root-image").addClass(t), $(".country-icons-list-countryflag-root-countryname").text(i), $(".country-icons-list-first-item .country-icons-list-countryflag-image").attr("class", function(k, c) {
              return c.replace(/(^|\s)flag-\S+/g, "")
          }), $(".country-icons-list-first-item .country-icons-list-countryflag-image").addClass(t), $(".country-icons-list-first-item .country-icons-list-countryname").text(i)) : (console.log("Default flag"), i = "United States", a = "llc", t = "flag-united_states", l = "USD", e = !0);
          var f = js_readCookie("ipcontinentcode"),
              P = js_readCookie("ipcountrycode");
          if (f == null || P == null) {
              console.log("Fetch country cookies");
              var m = document.createElement("script");
              m.setAttribute("type", "text/javascript"), m.setAttribute("src", "https://api.ipapi.com/check?fields=continent_code,country_code&access_key=3742ce0ca7d98abcc13be1c1d3248b37&callback=geoWorldRedirect"), document.getElementsByTagName("head")[0].appendChild(m)
          } else e == !0 && (js_createCookie("ipcountryddname", i, 365), js_createCookie("ipcountryddflag", t, 365), js_createCookie("ipcountryddstore", a, 365), js_createCookie("ipcountryddcurrency", l, 365)), console.log("Read country cookies '" + P + "' '" + f + "'"), geoWorld(P, f, a, t, !1)
        } catch (kx) {}
      }, 2000);
    } catch (k) {
        console.log("ERROR err_ready_countryicons: "+k.message) }
}), $(document).on("click", ".mobile-country-icons-list-close", function() {
    try {
        /*console.log("close country dd"),*/
        $(".mobile-country-icons-list").hasClass("shown") && ($(".mobile-country-icons-list").removeClass("shown").addClass("hidden"), $(".main-content").removeClass("bodyoff"), $("body").removeClass("bodyoff")), $(".mobile-nav-trigger.hamburger.hamburger--spin.is-active .hamburger-box").css("visibility", "visible")
    } catch {}
}), $(document).on("click", ".country-icons-list-item-first", function() {
    try {
        /*console.log("close country dd"),*/
        $(".mobile-country-icons-list").hasClass("shown") && $(".mobile-country-icons-list").removeClass("shown").addClass("hidden"), $(".mobile-nav-trigger.hamburger.hamburger--spin.is-active .hamburger-box").css("visibility", "visible"), $(".main-content").removeClass("bodyoff"), $("body").removeClass("bodyoff")
    } catch {}
}), $(document).on("click", ".mobile-country-icons-list-open", function() {
    try {
        /*console.log("open country dd"),*/
        $(".mobile-country-icons-list").hasClass("hidden") && $(".mobile-country-icons-list").removeClass("hidden").addClass("shown"), $(".main-content").addClass("bodyoff"), $("body").addClass("bodyoff")
    } catch {}
}), $(document).on("click", '.mobile-nav-trigger.hamburger--spin[aria-expanded="true"]', function() {
    try {
        $(".main-content").addClass("bodyoff"), $("body").addClass("bodyoff")
    } catch {}
}), $(document).on("click", '.mobile-nav-trigger.hamburger--spin[aria-expanded="false"]', function() {
    try {
        $(".main-content").removeClass("bodyoff"), $("body").removeClass("bodyoff"), $(".mobile-country-icons-list").hasClass("shown") && $(".mobile-country-icons-list").removeClass("shown").addClass("hidden")
    } catch {}
});

function setInnerHeight() {
    try {
        let i = window.innerHeight * .01;
        document.documentElement.style.setProperty("--onevh", `${i}px`)
    } catch (i) {
        /*console.log("ERROR: "+i.message)*/ }
}
setInnerHeight(), $(window).resize(function() {
    try {
        /*console.log("Resize"),*/
        $('.mobile-nav-trigger.hamburger--spin[aria-expanded="true"]').click(), setInnerHeight()
    } catch {}
}), $(document).on("keyup change", ".country-autocomplete", function() {
    try {
        var i = $(".country-autocomplete").val().toLowerCase().trim(); /*console.log("Autocomplete "+i),*/
        i.length >= 1 ? ($(".country-icons-list-first-item").hide(), $(".country-icons-list-item[lname*='" + i + "']").show(), $(".country-icons-list-item").not("[lname*='" + i + "']").hide()) : ($(".country-icons-list-first-item").show(), $(".country-icons-list-item").show())
    } catch {}
}), $(document).on("keyup change", ".country-autocomplete-mobile", function() {
    try {
        var i = $(".country-autocomplete-mobile").val().toLowerCase().trim(); /*console.log("Autocomplete "+i),*/
        i.length >= 1 ? ($(".country-icons-list-first-item").hide(), $(".country-icons-list-item[lname*='" + i + "']").show(), $(".country-icons-list-item").not("[lname*='" + i + "']").hide()) : ($(".country-icons-list-first-item").show(), $(".country-icons-list-item").show())
    } catch {}
}), $(document).on("keyup change", ".country-autocomplete-footer", function() {
    try {
        var i = $(".country-autocomplete-footer").val().toLowerCase().trim(); /*console.log("Autocomplete "+i),*/
        i.length >= 1 ? ($(".country-icons-list-first-item").hide(), $(".country-icons-list-item[lname*='" + i + "']").show(), $(".country-icons-list-item").not("[lname*='" + i + "']").hide()) : ($(".country-icons-list-first-item").show(), $(".country-icons-list-item").show())
    } catch {}
});

// Re-selecting the country you are already on: the "(selected)" row carries no
// store/currency attributes, so take them from the saved cookies and run the same
// path a normal pick takes. Lets someone force the currency back after a switch.
$(document).on("click", ".country-icons-list-first-item", function () {
    try {
        var a = js_readCookie("ipcountryddstore"),
            t = js_readCookie("ipcountryddflag"),
            l = js_readCookie("ipcountryddcurrency"),
            P = js_readCookie("ipcontinentcode"),
            m = js_readCookie("ipcountrycode");
        if (a == null || a == "" || P == null || P == "") return;
        $(".desktop-country-icons-list").removeClass("shown").addClass("hidden");
        $(".mobile-country-icons-list").removeClass("shown").addClass("hidden");
        $(".main-content").removeClass("bodyoff"), $("body").removeClass("bodyoff");
        geoWorld(m, P, a, t, l, true);
    } catch (k) { console.log("ERROR err_country_first_click: " + k.message) }
});

// The pinned row for whatever is already selected is redundant, so drop it.
// The selection is only known from the cookie, hence doing this client-side.
$(document).ready(function () {
    try {
        var sel = js_readCookie("ipcountryddname");
        if (sel == null || sel == "") sel = $(".country-icons-list-first-item .country-icons-list-countryname").first().text();
        sel = $.trim(sel || "");
        $(".country-icons-list-pinned").removeClass("country-pinned-selected");
        if (sel) $('.country-icons-list-pinned[name="' + sel + '"]').addClass("country-pinned-selected");
    } catch (k) { console.log("ERROR err_pinned_hide: " + k.message) }
});
